import React from 'react';
import BaseIcon from './BaseIcon';

class FolderSVG extends BaseIcon {
  render() {
    const { fillColor, height, width } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid"
        width={width}
        height={height}
        viewBox="0 0 48 37.875"
      >
        <path
          d="M45 37.87H3c-1.654 0-3-1.341-3-2.99V2.979a2.998 2.998 0 013-2.99h14.866c.046 0 .086.02.13.026.069.009.136.017.203.04.066.024.123.06.182.096.038.023.081.032.117.062l5.858 4.76H45a3 3 0 013 2.991V34.88a2.998 2.998 0 01-3 2.99zM3 35.876h42c.552 0 1-.446 1-.996V12.875H2V34.88c0 .55.448.996 1 .996zM45 6.875H24.417a.997.997 0 01-1.049-.132l-5.99-4.868H3c-.552 0-1 .554-1 1.104v7.975h44v-2.99c0-.55-.448-1.089-1-1.089z"
          fill={fillColor}
          fillRule="evenodd"
        />
      </svg>
    );
  }
}

export default FolderSVG;
